import { practitionerPortal } from "./practitioner-portal";
import { patientPortal } from "./patient-portal";
import { AppModule } from "./routing/app-module";

export const app: AppModule = {
  routes: [...patientPortal.routes, ...practitionerPortal.routes],
};
